import type { ConstantsMap } from "@/composables/options/options"
import { buildOptionsFromConstantsMap } from "@/composables/options/options"

// Keep in sync with essential.utils.export.FileTypeEnum
const FILE_EXPORT_FORMAT_MAP = {
  Csv: {
    label: "csv",
    value: "csv",
  },

  Xlsx: {
    label: "xlsx",
    value: "xlsx",
  },
  Ods: {
    label: "ods",
    value: "ods",
  },
} as const satisfies ConstantsMap

export type FileExportFormat =
  (typeof FILE_EXPORT_FORMAT_MAP)[keyof typeof FILE_EXPORT_FORMAT_MAP]["value"]

const _options = buildOptionsFromConstantsMap(
  FILE_EXPORT_FORMAT_MAP
)

export const useFileExportFormatOptions = () => ({
  options: _options,
  getLabelForValue: (value: FileExportFormat) =>
    computed(
      () =>
        _options.find((option) => option.value === value)
          ?.label || ""
    ),
})
